var path = 'visualizer/js/modules/visualization/histogram/histogram.tpl.html';
var html = "<div ng-class=\"{ 'histogram-component': true, 'clickable': isClickable }\"> <svg ng-show=data.length></svg> </div>";
window.angular.module('templates-visualizer').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;